import { QUESTS, type QuestDef } from "@cookies/shared/catalog/display"
import { toNum } from "../format"
import type { Snapshot } from "../types"

export function questCurrent(q: QuestDef, snap: Snapshot | null): number {
  if (!snap) return 0
  const contribution = toNum(snap.me.contribution ?? "0")
  const totalClicks = toNum(snap.me.totalClicks ?? "0")
  const combo = snap.me.combo ?? 0
  const active = snap.players.filter((p) => p.active).length
  const cookies = toNum(snap.bakery.lifetimeCookies ?? snap.bakery.cookies)
  const cps = toNum(snap.bakery.cps)
  const bakerLevel = snap.me.level ?? 1
  const projectsDone = snap.projects?.filter((p) => p.status === "completed").length ?? 0
  switch (q.id) {
    case "click100":
    case "click500":
    case "click5k":
    case "click25k":
    case "click100k":
    case "click1m":
      return totalClicks
    case "bake_with3":
      return active
    case "team5":
      return active
    case "contribute5k":
      return contribution
    case "contrib50k":
      return contribution
    case "contrib250k":
      return contribution
    case "contrib1m":
      return contribution
    case "contrib10m":
      return contribution
    case "contrib100m":
      return contribution
    case "team_combo":
    case "combo_weekly":
      return Math.min(q.target, combo)
    case "combo3":
      return Math.min(3, combo)
    case "daily_contract":
      return projectsDone >= 1 ? 1 : 0
    case "combo10":
      return Math.min(10, combo)
    case "combo20":
      return Math.min(20, combo)
    case "combo30":
      return Math.min(30, combo)
    case "complete_contract":
      return projectsDone
    case "contract5":
      return projectsDone
    case "contract8":
      return projectsDone
    case "bake_1m":
      return cookies
    case "bake10m":
      return cookies
    case "bake100m":
      return cookies
    case "bake1b":
      return cookies
    case "bake10b":
      return cookies
    case "golden_week":
      return 0
    case "golden10":
      return 0
    case "golden100":
      return 0
    case "golden1000":
      return 0
    case "mini100":
    case "mini1k":
    case "mini10k":
    case "sneaky100":
    case "sneaky1k":
      return 0
    case "cps50":
      return cps
    case "cps500":
      return cps
    case "cps5k":
      return cps
    case "cps25k":
      return cps
    case "cps100k":
      return cps
    case "baker_lv5":
      return bakerLevel
    case "baker_lv10":
      return bakerLevel
    case "baker_lv15":
      return bakerLevel
    case "bakery_lv8":
      return snap.bakery.level ?? 1
    case "bakery_lv12":
      return snap.bakery.level ?? 1
    case "spec_choose":
      return (snap.me.lastSpecLevel ?? 0) > 0 ? 1 : 0
    case "rush_catch":
      return 0
    default:
      return 0
  }
}

export { QUESTS }
export type { QuestDef }
